import { createClient } from "@supabase/supabase-js";

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseAnonKey);
window.supabase = supabase;

export const supabaseCustomSignOut = async () => {
  const result = await supabase.auth.signOut({ scope: "global" });

  try {
    const keysToRemove = Object.keys(localStorage).filter((key) => key.startsWith("sb-"));
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    localStorage.removeItem("supabase.auth.token");
  } catch (error) {
    console.warn("Failed to clear localStorage during signout:", error);
  }

  return result;
};

export const localStorageContainsAuthData = (): boolean => {
  try {
    return Object.keys(localStorage).some((key) => {
      if (key.startsWith("sb-")) {
        const storageValue = localStorage.getItem(key);
        return Boolean(storageValue && storageValue.includes("access_token"));
      }
      return false;
    });
  } catch {
    return false;
  }
};

export default supabase;
